"use client"

import React from "react"
import PropTypes from "prop-types"
import { Search } from "lucide-react"
import styles from "../css/components/searchbar.module.css"

export default function SearchBar({
  value,
  onChange,
  placeholder,
  containerStyle,
  inputStyle,
  containerClassName,
  inputClassName,
  iconSize,
  iconColor,
}) {
  return (
    <div className={[styles.searchContainer, containerClassName].filter(Boolean).join(" ")} style={containerStyle}>
      <Search size={iconSize || 16} className={styles.icon} />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || "Search..."}
        className={[styles.input, inputClassName].filter(Boolean).join(" ")}
        style={inputStyle}
      />
    </div>
  )
}

SearchBar.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  containerStyle: PropTypes.object,
  inputStyle: PropTypes.object,
  containerClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  iconSize: PropTypes.number,
  iconColor: PropTypes.string,
}
